(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["joies-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      root.querySelectorAll('.joies-products').forEach((section) => {
        if (section.dataset.joiesReady) return;
        section.dataset.joiesReady = 'true';
        const rail = section.querySelector('.joies-product-rail');
        const previous = section.querySelector('[data-joies-prev]');
        const next = section.querySelector('[data-joies-next]');
        if (!rail || !previous || !next) return;
        const update = () => {
          previous.disabled = rail.scrollLeft <= 1;
          next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        };
        const move = (direction) => {
          const card = rail.querySelector('.joies-product-card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(rail).gap) || 10;
          const step = card.getBoundingClientRect().width + gap;
          const count = Math.max(1, Math.floor(rail.clientWidth / step));
          rail.scrollBy({ left: direction * step * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        rail.addEventListener('scroll', update, { passive: true });
        rail.addEventListener('keydown', (event) => {
          if (event.target !== rail) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        if (window.ResizeObserver) new ResizeObserver(update).observe(rail);
        update();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document));
    else setup(document);
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joies-product-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      root.querySelectorAll('.joies-products').forEach((section) => {
        if (section.dataset.joiesReady) return;
        section.dataset.joiesReady = 'true';
        const rail = section.querySelector('.joies-product-rail');
        const previous = section.querySelector('[data-joies-prev]');
        const next = section.querySelector('[data-joies-next]');
        if (!rail || !previous || !next) return;
        const update = () => {
          previous.disabled = rail.scrollLeft <= 1;
          next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        };
        const move = (direction) => {
          const card = rail.querySelector('.joies-product-card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(rail).gap) || 10;
          const step = card.getBoundingClientRect().width + gap;
          const count = Math.max(1, Math.floor(rail.clientWidth / step));
          rail.scrollBy({ left: direction * step * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        rail.addEventListener('scroll', update, { passive: true });
        rail.addEventListener('keydown', (event) => {
          if (event.target !== rail) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        if (window.ResizeObserver) new ResizeObserver(update).observe(rail);
        update();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document));
    else setup(document);
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joies-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Date recensioni in italiano (gg mese aaaa). Idempotente: ignora i testi già convertiti. */
  (() => {
    if (window.__joiesReviewDates) return;
    window.__joiesReviewDates = true;
    const format = new Intl.DateTimeFormat('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
    const localize = (root) => {
      root.querySelectorAll('.jdgm-carousel-item__timestamp').forEach((el) => {
        const date = el.textContent.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        if (date) el.textContent = format.format(new Date(Number(date[3]), Number(date[1]) - 1, Number(date[2])));
      });
    };
    let queued = false;
    const run = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; localize(document); });
    };
    const start = () => {
      localize(document);
      new MutationObserver(run).observe(document.body, { childList: true, subtree: true, characterData: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();
})();
